/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-05 11:39:52
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 15:18:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/TableListPageLayout/index.tsx
 */
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { Button, Input } from 'src/components/Antd/';
import { useI18n } from 'src/hooks/useRouterChange';
import Layout from 'src/layout/ListPageLayout/ListPageLayout';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
//import DropDown from 'src/components/Antd/DropDown/DropDown';

const _Layout = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [search, setSearch] = React.useState('');
  const {
    title,
    addText,
    addFun,
    children,
    onSearch,
    breadcrumbData,
    addButtonOverlay,
    disableAdd,
  } = props;
  const handleOnSearch = () => {
    if (onSearch) {
      onSearch(search);
    }
  };

  return (
    <React.Fragment>
      <Breadcrumb className={css.breadcrumb} breadcrumbData={breadcrumbData} />
      <Layout
        title={title}
        addText={addText}
        addButtonOverlay={addButtonOverlay}
        addFun={addFun}
        disableAdd={disableAdd}
        //addButtonOverlay={addButtonOverlay}
      >
        <div className={css.searchInputContainer}>
          <div className={css.searchInput}>
            <Input
              value={search}
              onChange={setSearch}
              placeholder={getI18n('general.searchpageversionremarks')}
              prefix={<Icon type='iconlanguageCopy' />}
            />
          </div>
          <Button
            type='primary'
            onClick={handleOnSearch}
            className={css.searchBtn}>
            {getI18n('general.filterGroup.search')}
          </Button>
        </div>

        {children}
      </Layout>
    </React.Fragment>
  );
};
export default _Layout;
